<template>
  <div class="brand-culture" ref="brandCulture">
    <div class="culture-banner">
      <img src="~@/assets/icon/brandCulture/feedback_banner.jpg" alt="" />
    </div>
    <div class="brand-culture-bg">
      <second-title
        letter="A"
        enTitle="fter-sales service"
        current_add="品牌文化"
        add_one="首页"
        add_tow="品牌故事"
        add_three="品牌文化"
      >
      </second-title>
      <div class="content">
        <!-- 品牌文化 -->
        <div class="culture animate__animated animate__fadeInUp">
          <div class="culture-bg">
            <img
              class="culture-title"
              src="../../assets/icon/brandCulture/hone-content-titel.png"
              alt=""
            />
            <img
              class="culture-text"
              src="../../assets/icon/brandCulture/hone-content-text.png"
              alt=""
            />
          </div>
        </div>
        <!-- 品牌定位 -->
        <div
          ref="location"
          class="location-box"
          :class="{
            'animate__animated animate__fadeInUp animate__slow': showLocation,
          }"
        >
          <img
            class="location-img"
            src="../../assets/icon/brandCulture/brand-positioning-titel.png"
            alt=""
          />
          <div class="location">
            <div class="location-bg">
              <img
                class="location-text"
                src="../../assets/icon/brandCulture/brand-positioning-text.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <!-- 品牌主张 -->
        <div
          ref="proposition"
          class="proposition-box"
          :class="{
            'animate__animated animate__fadeInUp animate__slow':
              showProposition,
          }"
        >
          <img
            class="proposition-img"
            src="../../assets/icon/brandCulture/brand-proposition-titel.png"
            alt=""
          />
          <div class="proposition">
            <div class="proposition-bg">
              <img
                class="proposition-text"
                src="../../assets/icon/brandCulture/brand-proposition-text.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <!-- 品牌个性 -->
        <div
          ref="individuality"
          :class="{
            'animate__animated animate__fadeInUp animate__slow':
              showIndividuality,
          }"
        >
          <div class="individuality-titel">
            <img
              class="individuality-img"
              src="../../assets/icon/brandCulture/brand-personality-titel.png"
              alt=""
            />
          </div>
          <div class="individuality">
            <swiper :options="valueSwiperOptions">
              <swiper-slide v-for="(item, idx) in valueSwiperList" :key="idx">
                <div class="swiper-box">
                  <img :src="item.img" alt="" class="img" />
                  <div class="text">{{ item.title }}</div>
                </div>
              </swiper-slide>
              <div
                class="swiper-pagination swiper-clld-pagination"
                slot="pagination"
              ></div>
            </swiper>
          </div>
        </div>
        <!-- 品牌价值 -->
        <div
          ref="brandValue"
          :class="{
            'animate__animated animate__fadeInUp animate__slow': showBrandValue,
          }"
        >
          <div class="value-titel">
            <img
              class="value-img"
              src="../../assets/icon/brandCulture/brand-value-titel.png"
              alt=""
            />
          </div>
          <div class="value">
            <swiper :options="valueSwiperOptions">
              <swiper-slide v-for="(item, idx) in valueSwiperList1" :key="idx">
                <div class="swiper-box">
                  <img :src="item.img" alt="" class="img" />
                  <div class="text">
                    <p class="text-1">{{ item.title }}</p>
                    <p class="text-2">{{ item.sonTitle }}</p>
                  </div>
                </div>
              </swiper-slide>
              <div
                class="swiper-pagination swiper-clld-pagination"
                slot="pagination"
              ></div>
            </swiper>
          </div>
        </div>
        <!-- 品牌历程 -->
        <div
          :class="{
            'animate__animated animate__fadeInUp animate__slow': showPrevious,
          }"
        >
          <div class="previous-titel">
            <img
              class="previous-img"
              src="../../assets/icon/brandCulture/brand-course-titel.png"
              alt=""
            />
          </div>
          <van-tabs id="course" v-model="active" class="tabs-box">
            <div class="heng" ref="previous">
              <div class="previous" @click="previous">
                <img src="../../assets/icon/brandCulture/previous.png" alt="" />
              </div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="next" @click="next">
                <img src="../../assets/icon/brandCulture/next.png" alt="" />
              </div>
            </div>
            <van-tab
              :title="item.title"
              v-for="(item, idx) in tabsList"
              :key="idx"
            >
              <van-tabs swipeable class="tabs-box1">
                <van-tab
                  :title="item1.title"
                  v-for="(item1, idx1) in item.children"
                  :key="idx1"
                >
                  <div class="img-box">
                    <img class="course-img" :src="item1.img" alt="" />
                  </div>
                  <div class="course-text">
                    <p class="text-1">{{ item1.text1 }}</p>
                    <p class="text-2">{{ item1.text2 }}</p>
                    <p class="text-3">{{ item1.text3 }}</p>
                  </div>
                </van-tab>
              </van-tabs>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </div>
    <base-footers></base-footers>
  </div>
</template>
<script>
import ParticularsNavigation from "@/components/ParticularsNavigation.vue";
import SecondTitle from "@/components/SecondTitle.vue";
import Footers from "@/components/Footers.vue";
import { Tab, Tabs } from "vant";
export default {
  name: "brandCulture",
  components: {
    SecondTitle,
    ParticularsNavigation,
    BaseFooters: Footers,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data() {
    return {
      showLocation: false,
      showProposition: false,
      showIndividuality: false,
      showBrandValue: false,
      showPrevious: false,
      active: 0,
      active1: 1,
      tabsList: [
        {
          id: "1",
          title: "2018",
          children: [
            {
              id: "1",
              title: "2018.09",
              img: 'https://resource.vogemotor.com/accessory/2018.09.jpg',
              text1: "第十六届中国国际摩托车博览会",
              text2:
                "第十六届中国国际摩托车博览会，隆鑫旗下高端机车品牌“VOGE无极”正式发布，首款复古车无极300AC，首款500双缸街车500R同步上市，全民开始新时代大排之路",
              text3: "中国 · 重庆",
            },
          ],
        },
        {
          id: "2",
          title: "2019",
          children: [
            {
              id: "1",
              title: "2019.03",
              img: 'https://resource.vogemotor.com/accessory/2019.03.jpg',
              text1: "第一场VRT无极驾驶训练营",
              text2:
                "第一场VRT无极驾驶训练营西安站正式开营，无极开启机车文化新时代",
              text3: "中国 · 西安",
            },
            {
              id: "2",
              title: "2019.04",
              img: 'https://resource.vogemotor.com/accessory/2019.04.jpg',
              text1: "新车上市",
              text2: "无极500R ABS版本上市发售",
              text3: "中国 · 重庆",
            },
            {
              id: "3",
              title: "2019.07",
              img: 'https://resource.vogemotor.com/accessory/2019.07.jpg',
              text1: "新车上市",
              text2: "无极300AC ABS版本上市发售",
              text3: "中国 · 重庆",
            },
            {
              id: "4",
              title: "2019.09",
              img: 'https://resource.vogemotor.com/accessory/2019.09.jpg',
              text1: "第十七届中国国际摩托车博览会",
              text2:
                "第十七届中国国际摩托车博览会VOGE无极机车举办新品发布会，无极500DS/650DS/ER-10激擎上市。",
              text3: "中国 · 重庆",
            },
            {
              id: "5",
              title: "2019.11",
              img: 'https://resource.vogemotor.com/accessory/2019.11.jpg',
              text1: "VOGE无极品牌及新品全球发布会",
              text2: "VOGE无极品牌及新品全球发布会在意大利米兰隆重举行",
              text3: "意大利 · 米兰",
            },
          ],
        },
        {
          id: "3",
          title: "2020",
          children: [
            {
              id: "1",
              title: "2020.05",
              img: 'https://resource.vogemotor.com/accessory/2020.05.jpg',
              text1: "新车上市",
              text2: "云聚517——无极500DS上市发售",
              text3: "重庆 · 云阳",
            },
            {
              id: "2",
              title: "2020.08",
              img: 'https://resource.vogemotor.com/accessory/2020.08.jpg',
              text1: "VOGE地下雅丹发布会",
              text2:
                "VOGE地下雅丹发布会——无极300DS/300GY Rally上市,无极300R/300RR正式上市发售",
              text3: "青海 · 雅丹",
            },
            {
              id: "3",
              title: "2020.09",
              img: 'https://resource.vogemotor.com/accessory/2020.09.jpg',
              text1: "第十八届中国国际摩托车博览会",
              text2:
                "第十八届中国国际摩托车博览会VOGE无极机车以“乘风破浪，进取无极”为主题召开了2020年度发布会,无极300R/300RR正式上市发售",
              text3: "中国 · 重庆",
            },
          ],
        },

        {
          id: "4",
          title: "2021",
          children: [
            {
              id: "1",
              title: "2021.03",
              img: 'https://resource.vogemotor.com/accessory/2021.03.jpg',
              text1: "新车上市",
              text2: "先锋复古，无界唯潮——无极500AC领潮上市",
              text3: "中国 · 重庆",
            },
            {
              id: "2",
              title: "2021.05",
              img: 'https://resource.vogemotor.com/accessory/2021.05.jpg',
              text1: "联通杯无极挑战赛",
              text2: "首次举办联通杯无极挑战赛",
              text3: "中国 · 重庆",
            },
            {
              id: "3",
              title: "2021.09",
              img: 'https://resource.vogemotor.com/accessory/2021.09.jpg',
              text1: "第十九届中国国际摩托车博览会",
              text2:
                "第十九届中国国际摩托车博览会VOGE无极机车品牌战略升级，无极250RR与525R上市发售",
              text3: "中国 · 重庆",
            },
            {
              id: "4",
              title: "2021.11",
              img: 'https://resource.vogemotor.com/accessory/2021.11.jpg',
              text1: "隆鑫通用·VOGE机车首届文化艺术节",
              text2:
                "隆鑫通用·VOGE机车首届文化艺术节圆满举行，以“低碳动力，智慧产品领先品牌”为企业愿景，以“聚焦科技、创新驱动美好生活”为使命，实现实业强国、客户至上共同富裕，发布“匠心无极·随心所驭”新口号",
              text3: "中国 · 重庆",
            },
            {
              id: "5",
              title: "2021.12",
              img: 'https://resource.vogemotor.com/accessory/2021.12.jpg',
              text1: "新车上市",
              text2: "VOGE重磅亮相米兰EICMA国际摩托车展",
              text3: "意大利 · 米兰",
            },
          ],
        },
        {
          id: "5",
          title: "2022",
          children: [
            {
              id: "1",
              title: "2022.03.18",
              img: 'https://resource.vogemotor.com/accessory/2022.03.18.jpg',
              text1: "新车上市",
              text2: "无极首款大踏板SR4 MAX 及复古车350AC上市发售",
              text3: "中国 · 重庆",
            },
            {
              id: "2",
              title: "2022.06.29",
              img: 'https://resource.vogemotor.com/accessory/2022.06.29.jpg',
              text1: "西安国际摩托车博览会",
              text2: "无极参加西安国际摩托车博览会，并在现场发布无极SR150GT",
              text3: "中国 · 西安",
            },
            {
              id: "3",
              title: "2022.11",
              img: 'https://resource.vogemotor.com/accessory/2022.11.jpg',
              text1: "第二十届中国国际摩托车博览会",
              text2: "第二十届中国国际摩托车博览会VOGE无极机车新品发布，250RR竞技版上市和RR525开启盲订，KEN660四缸发动机首次亮相！",
              text3: "中国 · 重庆",
            },
          ],
        },
      ],
      // 品牌价值 Swiper
      valueSwiperOptions: {
        loop: true,
        autoplay: false, // 自动轮播
        speed: 1000, // 轮播速度
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      valueSwiperList: [
        {
          id: "1",
          img: require("@/assets/icon/brandCulture/brand-personality-1.png"),
          title: "纯粹",
        },
        {
          id: "2",
          img: require("@/assets/icon/brandCulture/brand-personality-2.png"),
          title: "激情",
        },
        {
          id: "3",
          img: require("@/assets/icon/brandCulture/brand-personality-3.png"),
          title: "进取",
        },
      ],
      valueSwiperList1: [
        {
          id: "1",
          img: require("@/assets/icon/brandCulture/brand-value-1.png"),
          title: "精控",
          sonTitle: "驭 探究“精控”之道",
        },
        {
          id: "2",
          img: require("@/assets/icon/brandCulture/brand-value-2.png"),
          title: "精工",
          sonTitle: "匠 锤炼“精工”之魂",
        },
        {
          id: "3",
          img: require("@/assets/icon/brandCulture/brand-value-3.png"),
          title: "精美",
          sonTitle: "极 雕琢“精美”之感",
        },
      ],
    };
  },
  mounted() {
    var hash = window.location.hash;
    var index = hash.lastIndexOf("course");
    if (index != -1) {
      setTimeout(() => {
        this.$el.querySelector("#course").scrollIntoView();
      }, 500);
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 上一页
    previous() {
      if (this.active != 0) {
        this.active = this.active - 1;
      }
    },
    // 下一页
    next() {
      if (this.active != this.tabsList.length - 1) {
        this.active = this.active + 1;
      }
    },
    // 滑动监听
    handleScroll() {
      // 品牌定位
      let locationViewTop = this.$refs.location.getBoundingClientRect();
      if (locationViewTop.top <= window.innerHeight) {
        this.showLocation = true;
      }
      if (locationViewTop.bottom <= 50) {
        this.showLocation = false;
      }
      // 品牌主张
      let propositionViewTop = this.$refs.proposition.getBoundingClientRect();
      if (propositionViewTop.top <= window.innerHeight) {
        this.showProposition = true;
      }
      if (propositionViewTop.bottom <= 50) {
        this.showProposition = false;
      }
      // 品牌个性
      let individualityViewTop =
        this.$refs.individuality.getBoundingClientRect();
      if (individualityViewTop.top <= window.innerHeight) {
        this.showIndividuality = true;
      }
      if (individualityViewTop.bottom <= 50) {
        this.showIndividuality = false;
      }
      // 品牌价值
      let brandValueViewTop = this.$refs.brandValue.getBoundingClientRect();
      if (brandValueViewTop.top <= window.innerHeight) {
        this.showBrandValue = true;
      }
      if (brandValueViewTop.bottom <= 50) {
        this.showBrandValue = false;
      }
      // 品牌历程
      let previousViewTop = this.$refs.previous.getBoundingClientRect();
      if (previousViewTop.top <= window.innerHeight) {
        this.showPrevious = true;
      }
      if (previousViewTop.bottom <= 50) {
        this.showPrevious = false;
      }
      // 品牌历程 showPrevious
      // if ((this.currentScroll > this.$refs.previous.offsetTop-700) && this.$refs.previous.offsetTop != 0) {
      //     this.showPrevious = true
      // }
    },
  },
  // 离开页面销毁滑动监听
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss">
@import "./brandCulture.scss";
</style>